"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "../tags.model";
export let TrafficpackageModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.originalPrice = 0;
    this.price = 0;
    this.sort = 0;
    this.description = "";
    this.currency = "";
    this.payments = [];
    this.marks = new TagsModel();
    this.infoTags = [];
    this.leftTags = [];
    this.rightupper_tags = [];
    this.lable_tags = [];
  }
};
TrafficpackageModel.model = "traffic.model";
TrafficpackageModel = __decorateClass([
  Annotation.ModelMeta
], TrafficpackageModel);
